module.exports = __webpack_public_path__ + "static/media/app-store.8237b1bc.png";